export const secretHalf = "4dbc9ff6c15944d7";
